export default __webpack_public_path__ + "static/do-focus-at-start-b274df2f90695626168033319eaa636661abb36f728b8c85002cf998ca85eb58.png";